module.exports = __webpack_public_path__ + "img/title.71977ea9.png";